import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import Nav from './nav';



const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const StyledRoot = styled('div')({
    display: 'flex',
    minHeight: '100%',
    overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
    flexGrow: 1,
    overflow: 'auto',
    minHeight: '100%',
    paddingTop: APP_BAR_MOBILE,
    paddingBottom: theme.spacing(10),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    [theme.breakpoints.up('lg')]: {
        paddingTop: APP_BAR_DESKTOP + 38,
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(5),
    },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
    const [openNav, setOpenNav] = useState(false);
    const toggleNav = () => setOpenNav(true);

    const handleCloseDrawer = () => {
        setOpenNav(false);
    };

    return (
            <StyledRoot>
                <Header toggleNav={toggleNav} />

                <Nav openNav={openNav} handleCloseDrawer={handleCloseDrawer} />

                <Main sx={{background: '#F7FFFE'}}>
                    <Outlet />
                </Main>
            </StyledRoot>
    );
}
